import React from 'react'
import Text from '../../Text'
import Spacer from '../../Spacer'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'

function RichText(props) {
  const { text } = props

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Spacer size={96} />
          <SimpleBlockContent blocks={text}/>
        <Spacer size={96} />
      </div>
    </div>
  )
}

export default RichText
